import axios from '../../bootstrap';

/**
 * @param {string} urlGetButton
 */
export function axiosGetButtonCSS(urlGetButton) {
    return axios.get(urlGetButton);
}
